import { i18n } from '../../i18n/translate';
import type { MenuEnvironment, MenuItem } from './types';

export const learnerNavigation = (environment: MenuEnvironment): MenuItem => {
  const { MENU_DOMAIN_FOR_ADMINIFI, MENU_DOMAIN_FOR_FRONT_END } = environment;
  return {
    id: 'foundry--universal_navigation--menus--learner_navigation',
    type: 'menus',
    slug: 'foundry--universal_navigation--menus--learner_navigation',
    title: '',
    icon: '',
    font_family: '',
    css_class: '',
    target_url: '',
    target_method: '',
    new_window: false,
    subsection: false,
    weight: 100,
    submenu_items: [
      {
        id: 'app-switcher',
        slug: 'app-switcher',
        title: '',
        icon: '',
        font_family: '',
        css_class: '',
        target_url: '',
        target_method: '',
        new_window: false,
        subsection: true,
        submenu_items: [
          {
            id: 'train',
            slug: 'train',
            title: i18n.t('Train'),
            icon: '',
            font_family: '',
            css_class: '',
            permissions: [{ has_rule_set: ['he_cc_fs_scorm_manager_names'] }],
            target_url: `${MENU_DOMAIN_FOR_FRONT_END}/{{slug}}/cportal/actionable_dashboard`,
            target_method: '',
            new_window: false,
            subsection: false,
            submenu_items: [],
            weight: 100,
          },
          {
            id: 'impact',
            slug: 'impact',
            title: i18n.t('Impact'),
            icon: '',
            font_family: '',
            css_class: '',
            permissions: [{ has_capabilities: ['Capabilities::ImpactDashboard'], has_rule_set: ['executive'] }],
            target_url: `${MENU_DOMAIN_FOR_FRONT_END}/{{slug}}/ceos/impact-dashboard`,
            target_method: '',
            new_window: false,
            subsection: false,
            submenu_items: [],
            weight: 100,
          },
          {
            id: 'learn',
            slug: 'learn',
            title: i18n.t('Learn'),
            icon: '',
            font_family: '',
            css_class: '',
            permissions: [{ has_rule_set: ['he_cc_fs_learner_names'] }],
            target_url: `${MENU_DOMAIN_FOR_FRONT_END}/{{slug}}/student/dashboard`,
            target_method: '',
            new_window: false,
            subsection: false,
            submenu_items: [],
            weight: 100,
          },
          {
            id: 'promote',
            slug: 'promote',
            title: i18n.t('Promote'),
            icon: '',
            font_family: '',
            css_class: '',
            permissions: [{ has_rule_set: ['advisors'] }],
            target_url: `${MENU_DOMAIN_FOR_FRONT_END}/{{slug}}/cportal/actionable_dashboard`,
            target_method: '',
            new_window: false,
            subsection: false,
            submenu_items: [],
            weight: 100,
          },
          {
            id: 'promote',
            slug: 'promote',
            title: i18n.t('Promote'),
            icon: '',
            font_family: '',
            css_class: '',
            permissions: [{ has_rule_set: [{ next_managers: 'at_work_manager' }] }],
            target_url: `${MENU_DOMAIN_FOR_FRONT_END}/{{slug}}/cportal/financial_launchpad`,
            target_method: '',
            new_window: false,
            subsection: false,
            submenu_items: [],
            weight: 100,
          },
          {
            id: 'engage',
            slug: 'engage',
            title: i18n.t('Engage'),
            icon: '',
            font_family: '',
            css_class: '',
            permissions: [{ has_rule_set: ['engage_managers'] }],
            target_url: `${MENU_DOMAIN_FOR_FRONT_END}/{{slug}}/cportal/actionable_dashboard`,
            target_method: '',
            new_window: false,
            subsection: false,
            submenu_items: [],
            weight: 100,
          },
        ],
      },
      {
        id: '',
        slug: '',
        title: '{{user_name}}',
        icon: 'circle-user',
        font_family: '',
        css_class: 'account',
        target_url: '',
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [
          {
            id: 'my_profile',
            slug: '',
            title: i18n.t('My Profile'),
            icon: '',
            font_family: '',
            css_class: '',
            target_url: `${MENU_DOMAIN_FOR_FRONT_END}/{{slug}}/student/registrations/edit`,
            target_method: '',
            new_window: false,
            subsection: false,
            submenu_items: [],
            weight: 100,
          },
          {
            id: 'logout',
            slug: 'logout',
            title: i18n.t('Logout'),
            icon: '',
            font_family: '',
            css_class: '',
            target_url: `${MENU_DOMAIN_FOR_ADMINIFI}/{{slug}}/sign_out`,
            target_method: 'GET',
            new_window: false,
            subsection: false,
            submenu_items: [],
            weight: 100,
          },
          {
            id: '',
            slug: '',
            title: '',
            icon: '',
            font_family: '',
            css_class: '',
            target_url: '',
            target_method: '',
            new_window: false,
            subsection: true,
            weight: 99,
            submenu_items: [
              {
                id: '',
                slug: '',
                title: i18n.t('Help'),
                icon: 'circle-question',
                font_family: '',
                css_class: '',
                comment: 'needs to open a modal',
                target_url: 'help_modal',
                target_method: '',
                new_window: false,
                subsection: false,
                submenu_items: [],
                weight: 100,
              },
              {
                id: '',
                slug: '',
                title: i18n.t('Terms of Service'),
                icon: 'shield-check',
                font_family: '',
                css_class: '',
                target_url: 'https://everfi.com/terms-of-service',
                target_method: '',
                new_window: true,
                subsection: false,
                submenu_items: [],
                weight: 100,
              },
              {
                id: '',
                slug: '',
                title: i18n.t('Language'),
                icon: 'language',
                font_family: '',
                css_class: '',
                permissions: [{ has_rule_set: ['he_cc_fs_learner_names'] }],
                comment: 'open a modal.',
                target_url: 'language_modal',
                target_method: '',
                new_window: false,
                subsection: false,
                submenu_items: [],
                weight: 100,
              },
            ],
          },
        ],
      },
    ],
  };
};
